export default "__VITE_ASSET__CtwZbus6__"